import { render, staticRenderFns } from "./ProjectSearchBar.vue?vue&type=template&id=2d0a2098&scoped=true&"
import script from "./ProjectSearchBar.vue?vue&type=script&lang=js&"
export * from "./ProjectSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSearchBar.vue?vue&type=style&index=0&id=2d0a2098&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0a2098",
  null
  
)

export default component.exports